import { Icon } from '@chakra-ui/react';

export default function SFEyeSlash(props) {
  return (
    <Icon
      xmlns='http://www.w3.org/2000/svg'
      width='22px'
      height='15px'
      viewBox='0 0 22 15'
      fill='currentColor'
      {...props}
    >
      <path d='M17.078 14.133 4.008 1.078a.62.62 0 0 1 0-.851.613.613 0 0 1 .86 0L17.93 13.28c.234.242.258.594 0 .852a.577.577 0 0 1-.852 0M11 .672c6.313 0 10.672 5.094 10.672 6.695 0 .922-1.469 3.024-3.938 4.625l-.96-.96c2.163-1.329 3.53-3.032 3.53-3.665 0-.93-4.163-5.46-9.304-5.46-.969 0-1.852.148-2.71.406L7.257 1.289A11.7 11.7 0 0 1 11 .672m0 13.39C4.766 14.063.32 8.962.32 7.368c0-.945 1.547-3.11 4.149-4.719l.968.97C3.134 5 1.688 6.82 1.688 7.367c0 1.1 4.165 5.46 9.313 5.46 1.055 0 2.04-.172 2.969-.46l1.023 1.023a12.3 12.3 0 0 1-3.992.672m4.008-4.984L9.28 3.352a4.3 4.3 0 0 1 1.72-.36c2.43 0 4.383 1.93 4.383 4.375 0 .602-.133 1.188-.375 1.711M11 11.742a4.403 4.403 0 0 1-4.398-4.375c0-.703.164-1.36.453-1.937l5.86 5.86a4.4 4.4 0 0 1-1.915.452' />
    </Icon>
  );
}
